import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { Desktop, Mobile } from '../../../../../App';
import { BV, formatVP } from '../../../../../helpers/helperFunctions';
import { CaptionText, P3 } from '../../../../../styles/FontStyles';
import { UserImageCircle } from '../../../../../styles/GlobalComponents';
import { color } from '../../../../../styles/GlobalStyles';
import { Icon, IconStructureAlert } from '../../../../../styles/Icons';
import {
  getRootTeamMember,
  openAddNewMemberModal
} from '../../../myTeamBackOffice.actions.js';
import {
  FlexCenterEqual,
  LevelOneImgName,
  LevelOneWrap,
  AlertIcon,
  AlertWrapper
} from '../../../MyTeamBackofficeStyled';
import { StructurePlusButton } from '../StructurePlusButton/StructurePlusButton';
import { StructureType } from '../../../myTeamBackOffice.constants';
import { useAppSelector } from '../../../../../app/hooks';

export const LevelOne = ({ teamMember, parentId, position }) => {
  const { t } = useTranslation('myTeam');

  const dispatch = useDispatch();
  const onPlusClick = () => {
    if (parentId) dispatch(openAddNewMemberModal(parentId, position));
  };
  const { rootTeamMember } = useSelector((state) => state.myTeamBackoffice);

  const { isCanadaRestrictedUser } = useAppSelector(
    (state) => state.auth.userInfo
  );

  return (
    <LevelOneWrap disabled={!teamMember && isCanadaRestrictedUser}>
      {teamMember ? (
        <>
          <LevelOneImgName
            onClick={() => {
              if (teamMember.id === rootTeamMember.id) return;
              dispatch(getRootTeamMember(teamMember.id, StructureType.TEAM));
            }}>
            {teamMember?.hasNoPackage ||
            teamMember?.hasUnpaidPackage ||
            teamMember?.isNotQualifiedPartner ||
            teamMember?.isUserNotVerified ? (
              <AlertWrapper>
                <UserImageCircle
                  image={teamMember?.profileImageUrl}
                  avatar
                  avatarSize='20px'
                  size='40px'
                  margin='0 0 4px 0'
                />
                <AlertIcon color={color.colors.error500}>
                  <Icon pointer w='34px' color={color.colors.neutral50}>
                    <IconStructureAlert width={3} height={10} />
                  </Icon>
                </AlertIcon>
              </AlertWrapper>
            ) : (
              <UserImageCircle
                image={teamMember?.profileImageUrl}
                avatar
                avatarSize='20px'
                size='40px'
                margin='0 0 4px 0'
              />
            )}

            <P3
              center
              mb='5'
              color={color.colors.neutral900}
              style={{ maxWidth: '100%' }}>
              <div className='truncated'>
                <div>{teamMember?.username ?? `#${teamMember?.id}`}</div>
              </div>
            </P3>
          </LevelOneImgName>

          <Desktop style={{ width: '100%' }}>
            <FlexCenterEqual>
              <div>
                <h3>{t('left_team')}</h3>
                <h2>
                  {formatVP(teamMember?.leftLegTotalVolume) ?? 0} {BV}
                </h2>
              </div>
              <div>
                <h3>{t('right_team')}</h3>
                <h2>
                  {formatVP(teamMember?.rightLegTotalVolume) ?? 0} {BV}
                </h2>
              </div>
            </FlexCenterEqual>
          </Desktop>
          <Mobile>
            <CaptionText color={color.colors.neutral500}>
              {t('id')}: {teamMember.id}
            </CaptionText>
          </Mobile>
        </>
      ) : (
        // <div
        //   style={{
        //     display: 'flex',
        //     alignItems: 'center',
        //     justifyContent: 'center',
        //     cursor: 'pointer',
        //   }}
        //   onClick={onPlusClick}
        // >
        //   <img src={add} alt='avatar' />
        // </div>

        <StructurePlusButton onClick={onPlusClick} />
      )}
    </LevelOneWrap>
  );
};
